module.exports = __webpack_public_path__ + "static/media/pamplemousse.676f0c68.svg";